import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

interface MobileTabProps {
  title: string;
}

const MobileTab = ({ title }: MobileTabProps) => {
  const navigate = useNavigate();
  return (
    <div className="w-full relative h-16 flex justify-center items-center px-3">
      <div className="absolute left-4" onClick={() => navigate(-1)}>
        <IoArrowBackOutline size={28} />
      </div>
      <div className="text-lg font-semibold">{title}</div>
    </div>
  );
};

export default MobileTab;
